const map = {
	"./WhatsApp Image 2025-01-16 at 10.56.18 PM (1).jpeg": 7269,
	"./WhatsApp Image 2025-01-16 at 10.56.18 PM.jpeg": 8063,
	"./WhatsApp Image 2025-01-16 at 10.56.19 PM.jpeg": 2010,
	"./WhatsApp Image 2025-01-16 at 10.56.21 PM.jpeg": 1247,
	"./WhatsApp Image 2025-01-16 at 10.56.22 PM (1).jpeg": 2626,
	"./WhatsApp Image 2025-01-16 at 10.56.22 PM.jpeg": 6808,
	"./WhatsApp Image 2025-01-16 at 10.56.23 PM.jpeg": 3781,
	"./WhatsApp Image 2025-01-16 at 10.56.25 PM.jpeg": 43,
	"./WhatsApp Image 2025-01-16 at 10.56.26 PM.jpeg": 1988,
	"./WhatsApp Image 2025-01-16 at 10.56.28 PM.jpeg": 5650
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2213;